/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

'use strict';

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = require('../utils/logger')('splitio-metrics');
var tracker = require('../utils/logger/timeTracker');

var repeat = require('../utils/fn/repeat');

var metricsService = require('../services/metrics');
var metricsServiceRequest = require('../services/metrics/post');
var metricsDTO = require('../services/metrics/dto');

var impressionsService = require('../services/impressions');
var impressionsBulkRequest = require('../services/impressions/bulk');
var impressionsDTO = require('../services/impressions/dto');

var MetricsFactory = function MetricsFactory(settings, storage) {
  var pushMetrics = function pushMetrics() {
    if (storage.metrics.isEmpty()) return _promise2.default.resolve();

    log.info('Pushing metrics');
    tracker.start(tracker.C.METRICS_PUSH);

    return metricsService(metricsServiceRequest(settings, {
      body: (0, _stringify2.default)(metricsDTO.fromGetTreatmentCollector(storage.metrics))
    })).then(function () {
      tracker.stop(tracker.C.METRICS_PUSH);
      return storage.metrics.clear();
    }).catch(function () {
      return storage.metrics.clear();
    });
  };

  var pushImpressions = function pushImpressions() {
    if (storage.impressions.isEmpty()) return _promise2.default.resolve();

    log.info('Pushing ' + storage.impressions.queue.length + ' impressions');
    tracker.start(tracker.C.IMPRESSIONS_PUSH);

    return impressionsService(impressionsBulkRequest(settings, {
      body: (0, _stringify2.default)(impressionsDTO.fromImpressionsCollector(storage.impressions))
    })).then(function () {
      tracker.stop(tracker.C.IMPRESSIONS_PUSH);
      return storage.impressions.clear();
    }).catch(function () {
      return storage.impressions.clear();
    });
  };

  var stopImpressionsPublisher = false;
  var stopPerformancePublisher = false;

  return {
    start: function start() {
      stopImpressionsPublisher = repeat(function (schedulePublisher) {
        return pushImpressions().then(function () {
          return schedulePublisher();
        });
      }, settings.scheduler.impressionsRefreshRate);

      stopPerformancePublisher = repeat(function (schedulePublisher) {
        return pushMetrics().then(function () {
          return schedulePublisher();
        });
      }, settings.scheduler.metricsRefreshRate);
    },
    stop: function stop() {
      stopImpressionsPublisher && stopImpressionsPublisher();
      stopPerformancePublisher && stopPerformancePublisher();
    }
  };
};

module.exports = MetricsFactory;


//////////////////
// WEBPACK FOOTER
// ../~/@splitsoftware/splitio/lib/metrics/index.js
// module id = 1211
// module chunks = 0